
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TableCard } from "../../../components";
import styles from './Periodical.module.scss';
import common from '../../../common';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Periodical({ cateIdx, type }) {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const pageid = queryParams.get('pageid');

    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [data4, setData4] = useState([]);

    const [headCategories, setHeadCategories] = useState([]);

    const tableLoadData = {
        tableType: 'Periodical',
        type: type,
        cate: [cateIdx]
    };

    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_table`, tableLoadData , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data);

                const headCategories = await fetchCateHeadData(); 
                filterDataByCategory(data, headCategories)
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    const headCateForm = {document_category_idx : 2}

    const fetchCateHeadData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_document_category_head_table`, headCateForm , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setHeadCategories(data);
                return data;
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    const filterDataByCategory = (data, headCategories) => {
        headCategories.forEach(category => {
            const filteredData = data.filter(item => item.headCate === category.name);
            if (category.idx === 1) {
                setData1(filteredData);
            } else if (category.idx === 2) {
                setData2(filteredData);
            } else if (category.idx === 3) {
                setData3(filteredData);
            } else if (category.idx === 4) {
                setData4(filteredData);
            }
        });
    }

    useEffect(() => {
        fetchData();
    }, []);
    
    const pageSize = 20;
    const categoryOptions = useMemo(() => [
        { label: '전체', value: '전체' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'contents' },
        { label: '작성자', value: 'member' },
    ], []);

    const [returnTableCard, setReturnTableCard] = useState(null);

    useEffect(() => {
        let selectedData = [];
        switch (pageid) {
            case 'all': //전체
                selectedData = data;
                break;
            case '1':
                selectedData = data1;
                break;
            case '2':
                selectedData = data2;
                break;
            case '3':
                selectedData = data3;
                break;
            case '4':
                selectedData = data4;
                break;
            default:
                selectedData = data; 
        }

        setReturnTableCard(
            <TableCard key={pageid} data={selectedData} pageSize={pageSize} categoryOptions={categoryOptions} type="Editor" />
        );
    }, [pageid, data, data2, data3, data4, pageSize, categoryOptions]);


    // const [activeTab, setActiveTab] = useState('all');
    const [activeTab, setActiveTab] = useState(1);

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        navigate(`?pageid=${tabIndex}`);
    };


    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>정기간행물</span>
                <div className={styles.tab_box}>
                    {/* <button
                        className={`${styles.tab_btn} ${activeTab === 'all' ? styles.active : ''}`}
                        onClick={() => handleTabClick('all')}
                    >
                        전체
                    </button> */}
                    {headCategories.map(category => (
                        <button
                            key={category.idx} 
                            className={`${styles.tab_btn} ${activeTab === category.idx ? styles.active : ''}`}
                            onClick={() => handleTabClick(category.idx)}
                        >
                            {category.name} 
                        </button>
                    ))}
                </div>
                {returnTableCard}
            </div>
        </>
    );
}

export default Periodical;